import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-baulas-information',
  templateUrl: './baulas-information.component.html',
  styleUrls: ['./baulas-information.component.css']
})
export class BaulasInformationComponent{
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private readonly dialogRef: MatDialogRef<BaulasInformationComponent>) {}

  /**
   * Handles submission of the modal dialog.
   * Closes the dialog and returns 'true' to indicate confirmation
   */
  public submitModal(): void {
    this.dialogRef.close(true);
  }
}
